import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const DialogTitle = withStyles(theme => ({
    root: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        margin: 0,
        padding: theme.spacing.unit * 2
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
        color: theme.palette.grey[500],
        marginLeft: 10
    },
}))(props => {
    const { children, classes, onClose } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="Close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing.unit * 2,
        minWidth: "300pt"
    },
}))(MuiDialogContent);

class ConfirmDialog extends React.Component {

    render() {
        return (
            <div>
                <Dialog
                    onClose={this.props.handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={this.props.open}
                >
                    <DialogTitle id="customized-dialog-title" onClose={this.props.handleClose}>
                        {this.props.title}
                    </DialogTitle>
                    <DialogContent>
                        <Typography gutterBottom>
                            {this.props.children}
                        </Typography>
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

ConfirmDialog.propTypes = {
    handleClose: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string
};

export default ConfirmDialog;
